export const routeEditItemIds = {
    userInterfaces: "userInterfaceId",
    documents: "documentId",
    catalogs: "catalogId",
    perspectiveBuilder: "customDataViewId",
    search: "dataViewsId",
    reports: "processAnalyticsId",
    statistics: "processAnalyticsId"
};
